import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { enTranslation } from './resources';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslation
      }
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if translation is missing
    interpolation: {
      escapeValue: false // React already escapes values
    },
    react: {
      useSuspense: false
    }
  })
  .catch((error: Error) => {
    console.error('Failed to initialize i18n:', error);
  });

export { i18n };
